import { Form } from '@mairistem/composants';
import dayjs from 'dayjs';
import { formatMonetaire } from '@/utils';

interface CesuProps {
  type: string;
  dateValidite: string;
  nombre: number;
  montantUnitaire: number;
}

const Cesu = (props: CesuProps) => {
  const {
    type: typeProps,
    dateValidite: dateProps,
    nombre: nombreProps,
    montantUnitaire: montantUnitaireProps,
  } = props;

  return (
    <Form.Group style={{ margin: 0, flex: 1 }}>
      <Form.Field inline width={2}>
        <label>CESU</label>
      </Form.Field>
      <Form.Field inline width={2}>
        Type
        {' : '}
        <label>{typeProps}</label>
      </Form.Field>
      <Form.Field inline width={3}>
        Date de validité
        {' : '}
        <label>{dayjs(dateProps).format('DD/MM/YYYY')}</label>
      </Form.Field>
      <Form.Field inline width={2}>
        Nombre
        {' : '}
        <label>{nombreProps}</label>
      </Form.Field>
      <Form.Field inline width={3}>
        Montant unitaire
        {' : '}
        <label>{formatMonetaire(montantUnitaireProps, 2)}</label>
      </Form.Field>
      <Form.Field
        inline
        width={4}
        // @ts-expect-error
        style={{ textAlign: 'right' }}
      >
        Montant
        {' : '}
        <label>{formatMonetaire(montantUnitaireProps * nombreProps, 2)}</label>
      </Form.Field>
    </Form.Group>
  );
};

export default Cesu;
